import * as React from 'react';

import Container from '../../helpers/Container';
import ImageObject from '../ImageObject';
import SvgImage from '../SvgImage';
import { HeroBannerProps } from './type';
import './styles.scss';

const HeroBanner = ({
  ariaHidden,
  backLink,
  children,
  colorTheme = 'blue',
  image,
  imageSize = 'half',
  isDarkened,
  isLanding,
  isForPage,
}: HeroBannerProps) => {
  const root = 'hero-banner';
  const classes = [
    root,
    `${root}--theme-${colorTheme}`,
  ];
  if (isDarkened) {
    classes.push(`${root}--darkened`);
  }
  if (image) {
    classes.push(`${root}--${imageSize}`);
  }
  if (!image) {
    classes.push(`${root}--no-image`);
  }
  if (isLanding) {
    classes.push(`${root}--landing`);
  }
  if (isForPage) {
    classes.push(`${root}--for-page`);
  }

  return (
    <div className={classes.join(' ')} aria-hidden={ariaHidden}>
      <div className={`${root}__pane`}>
        <div className={`${root}__content`}>
          <Container>
            <div className={`${root}__content__back-link`}>
              {backLink ? (
                <a href={backLink.url}>
                  <SvgImage aria-hidden="true" title="Back icon" reference="#icon-arrow-back" />
                  {backLink?.title}
                </a>
              ) : <span />}
            </div>

            <div className={`${root}__content__main`}>
              {children}
            </div>
          </Container>
        </div>
      </div>

      {!isLanding && (
        <div className={`${root}__pane`}>
          {image && (
            <div className={`${root}__image-container`}>
              <div className={`${root}__image`}>
                <ImageObject image={image} fitType="cover" useFocalPoint aspectRatio="1x1" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
